import { RED_BALL_TEXTURE_KEYS } from '.'

export const preLoadAssets = (scene: Phaser.Scene) => {
  const prefix = `/animations/red-ball/`
  if (!scene.textures.getTextureKeys().includes(RED_BALL_TEXTURE_KEYS.ATLAS)) {
    scene.load.multiatlas(
      RED_BALL_TEXTURE_KEYS.ATLAS,
      `${prefix}atlas/animation-red-ball-images.json`,
      `${prefix}atlas/`,
    )
  }
}
